import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CL from 'country-list';
import { connect } from 'react-redux';
import { Modal, Button, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { validateOpportunityContact } from '../../WinLossActions';
import { isObject, map } from 'lodash';
import TagTable from './tag-table';
import WindowResizeListener from '../../../../components/window-size-listener';

const countryList = CL().getNames().map(c => ({ id: c, name: c }));

class EditContactModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      tagContainerWidth: 0,
    };
    this.close = this.close.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectTags = this.handleSelectTags.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  close() {
    this.props.onClose();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isOpen: nextProps.contact !== null });
    const previousContact = this.props.contact || {};
    const nextContact = nextProps.contact || {};
    if (previousContact.contact_id !== nextContact.contact_id) {
      if (!nextContact.tags) {
        nextContact.tags = [];
      }
      if (!nextContact.priority) {
        nextContact.priority = 1;
      }
      this.props.initialize({ ...nextContact });
    }
  }

  onWindowResize() {
    if (this.tagContainer) {
      this.setState({ tagContainerWidth: this.tagContainer.offsetWidth });
    }
  }

  handleSubmit(data) {
    const { valid } = this.props;
    if (valid) {
      this.props.onContactChange(data);
      this.close();
    }
  }

  handleSelectTags(tags) {
    this.props.change('tags', map(tags, 'id'));
  }

  renderField({
    input, label, type, placeholder, options, className, multiple, noEmpty, componentClass, hint, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    const childOptions = options || [];
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        {componentClass === 'select' && <FormControl
          {...input}
          componentClass={componentClass}
          placeholder={placeholder}
          type={type}
          multiple={multiple}
          disabled={submitting}
        >
          {!multiple && !noEmpty && <option />}
          {childOptions.map((childOption) => {
            const o = isObject(childOption) ? childOption : { id: childOption, name: childOption };
            return (
              <option key={o.id} value={o.id}>{o.name}</option>
            );
          })}
        </FormControl>}
        {componentClass !== 'select' && <FormControl
          {...input}
          componentClass={componentClass}
          placeholder={placeholder}
          type={type}
          disabled={submitting}
        />}
        <FormControl.Feedback />
        {hint !== undefined && <HelpBlock>{hint}</HelpBlock>}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  render() {
    const { handleSubmit, program, submitting } = this.props;
    let { initiatives } = program;
    if (!initiatives) {
      initiatives = {};
    }
    const { isOpen, tagContainerWidth } = this.state;
    return (
      <Modal show={isOpen} backdrop="static" keyboard={false} onHide={this.close}>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Contact Info</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <Field
                name="first_name"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="First name"
                placeholder="contact's first name"
              />
              <Field
                name="last_name"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="Last name"
                placeholder="contact's last name"
              />
            </div>
            <div className="row">
              <Field
                name="title"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="Title"
                placeholder="contact's title"
              />
              <Field
                name="email"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="Email"
                placeholder="contact's email"
              />
            </div>
            <div className="row">
              <Field
                name="phone"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="Phone"
                placeholder="contact's phone"
              />
              <Field
                name="phone_extension"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="Extension"
                placeholder="contact's phone extension"
              />
            </div>
            <div className="row">
              <Field
                name="mobile_phone"
                className="col-sm-6"
                type="text"
                component={this.renderField}
                label="Mobile"
                placeholder="contact's mobile phone"
              />
              <Field
                name="mailing_address.country"
                type="text"
                className="col-sm-6"
                componentClass="select"
                component={this.renderField}
                label="Country"
                placeholder="Contact country"
                options={countryList}
              />
            </div>
            {initiatives.priorities !== undefined && initiatives.priorities.length > 0 && <Field
              name="priority"
              type="text"
              noEmpty
              componentClass="select"
              component={this.renderField}
              label="Contact priority"
              placeholder="contact priority"
              options={initiatives.priorities}
            />}

            {(initiatives.buyerRoles !== undefined || initiatives.buyerTypes !== undefined) && <div className="row">
              {initiatives.buyerRoles !== undefined && initiatives.buyerRoles.length > 0 && <Field
                name="buyer_role"
                className="col-sm-6"
                type="text"
                componentClass="select"
                component={this.renderField}
                label="Buyer Role"
                placeholder="Buyer role"
                options={initiatives.buyerRoles}
              />}
              {initiatives.buyerTypes !== undefined && initiatives.buyerTypes.length > 0 && <Field
                name="buyer_type"
                className="col-sm-6"
                type="text"
                componentClass="select"
                component={this.renderField}
                label="Buyer Type"
                placeholder="Buyer type"
                options={initiatives.buyerTypes}
              />}
            </div>}

            {initiatives.tags !== undefined && initiatives.tags.length > 0 && <FormGroup>
              <div ref={(el) => { this.tagContainer = el; }}>
                <ControlLabel>Opportunity Tags</ControlLabel>
                <TagTable
                  tags={initiatives.tags}
                  disabled={submitting}
                  width={tagContainerWidth}
                  selectedTags={this.props.selectedTags}
                  onSelectTags={this.handleSelectTags}
                />
                <WindowResizeListener onResize={this.onWindowResize} />
              </div>
            </FormGroup>}

            <div className="row">
              <Field
                name="notes"
                className="col-sm-12"
                component={this.renderField}
                label="Notes"
                componentClass="textarea"
                placeholder="enter notes specific to the contact here"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-6 col-sm-push-6">
                <div className="pull-right">
                  <Button bsStyle="primary" type="submit">
                    Save
                  </Button>
                </div>
              </div>
              <div className="col-sm-6 col-sm-pull-6">
                <div className="pull-left">
                  <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

EditContactModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  program: PropTypes.object,
  contact: PropTypes.object,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  change: PropTypes.func,
  initialize: PropTypes.func,
  valid: PropTypes.bool,
  onContactChange: PropTypes.func,
  onClose: PropTypes.func,
  selectedTags: PropTypes.array,
};
EditContactModal.defaultProps = {
  onContactChange: () => {},
  onClose: () => {},
};

const selector = formValueSelector('nominationEditContactForm'); // <-- same as form name

function mapStateToProps(state) {
  return {
    selectedTags: selector(state, 'tags'),
  };
}

const validate = values => validateOpportunityContact(values);

const EditContactModalForm = reduxForm({
  form: 'nominationEditContactForm',
  validate,
})(EditContactModal);

export default connect(mapStateToProps)(EditContactModalForm);
